function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.54 8.394h-.6l-.214-.205a4.957 4.957 0 00-.392-6.867 4.963 4.963 0 00-6.88.13 4.955 4.955 0 00-.131 6.877 4.962 4.962 0 006.87.392l.206.213v.601l3.234 3.232c.315.31.82.31 1.134 0a.806.806 0 000-1.133l-3.226-3.24zm-4.565 0a3.423 3.423 0 111.31-6.584 3.421 3.421 0 012.114 3.162 3.415 3.415 0 01-3.424 3.422z",
  fill: "#B6B6B6",
  fillRule: "nonzero"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), _ref);
}

export default SvgSearch;